import { LANDING } from "@/constants/testIds";
import { t } from "@/lib/i18n";
import { trackEvent } from "@/lib/analytics";

const SOCIALS = [
  { platform: "Facebook", href: "https://www.facebook.com/dubaidutyfree/", icon: "fa-facebook-f", testId: LANDING.socialFb, aria: "Facebook" },
  { platform: "X", href: "https://x.com/DubaiDutyFree", icon: "fa-x-twitter", testId: LANDING.socialTw, aria: "X / Twitter", label: "X" },
  { platform: "Instagram", href: "https://www.instagram.com/dubaidutyfree/", icon: "fa-instagram", testId: LANDING.socialIg, aria: "Instagram" },
  { platform: "TikTok", href: "https://www.tiktok.com/@dubaidutyfree", icon: "fa-tiktok", testId: LANDING.socialTt, aria: "TikTok" },
  { platform: "Weibo", href: "https://weibo.com/6666332581/profile", icon: "fa-weibo", testId: LANDING.socialWeibo, aria: "Weibo" },
  { platform: "WeChat", href: "https://mp.weixin.qq.com/cgi-bin/home", icon: "fa-weixin", testId: LANDING.socialWechat, aria: "WeChat" },
];

export default function SocialBar({ lang, onAdminClick }) {
  return (
    <section className="ddf-section ddf-social-section">
      <p className="ddf-follow">{t(lang, "follow_us")}</p>
      <div className="ddf-social-row">
        {SOCIALS.map((s) => (
          <div key={s.platform} className="ddf-social-item">
            <a
              href={s.href}
              target="_blank"
              rel="noreferrer"
              data-testid={s.testId}
              className="ddf-social"
              aria-label={s.aria}
              onClick={() => trackEvent("social_click", { platform: s.platform })}
            >
              <i className={`fa-brands ${s.icon}`} aria-hidden="true" />
            </a>
            <span className="ddf-social-label">{s.label || s.platform}</span>
          </div>
        ))}
      </div>
      <div className="ddf-admin-link-row">
        <button
          type="button"
          className="ddf-admin-link"
          onClick={onAdminClick}
          data-testid={LANDING.adminTextLink}
        >
          ADMIN
        </button>
      </div>
    </section>
  );
}
